<template>
  <div class="quote">
    <div class="quote-icon">
      <Icon name="eenvandaag-general:quote" role="presentation" />
    </div>
    <div class="quote-wrapper">
      <blockquote class="quote-blockquote">
        {{ quote }}
      </blockquote>
      <cite v-if="author" class="quote-author">
        {{ author }}
      </cite>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICmsContentQuotes } from '~~/types/_cms-types';
defineProps<ICmsContentQuotes>();
</script>

<style lang="postcss" scoped>
.quote {
  --quote-padding: var(--unit-16) var(--unit-36);
  --quote-gap: var(--unit-12);

  display: flex;
  flex-direction: column;
  padding: var(--quote-padding);
  position: relative;
  gap: var(--quote-gap);

  @media (--lg-viewport) {
    --quote-gap: var(--unit-16);
    --quote-padding: var(--unit-24) var(--unit-64);
  }
}

.quote-wrapper {
  --quote-wrapper-gap: var(--unit-8);

  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  word-wrap: break-word;
  gap: var(--quote-wrapper-gap);

  @media (--lg-viewport) {
    --quote-wrapper-gap: var(--unit-12);
  }
}

.quote-icon {
  --quote-icon-wrapper-size: var(--unit-36);
  --quote-icon-size: var(--unit-18);

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: hsl(var(--color-neutral-white));
  font-size: var(--quote-icon-size);
  width: var(--quote-icon-wrapper-size);
  height: var(--quote-icon-wrapper-size);
  background: var(--effect-gradient-brand);

  @media (--lg-viewport) {
    --quote-icon-wrapper-size: var(--unit-44);
    --quote-icon-size: var(--unit-22);
  }
}

.quote-blockquote {
  position: relative;
  color: hsl(var(--color-primary-900));

  @add-mixin heading-2xl;
}

.quote-author {
  font-style: normal;
  color: hsl(var(--color-primary-500));

  @add-mixin label-sm;
}
</style>
